import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ViedocToasterElement } from "../../../secure/elements/ViedocReactElements";
import * as loaderActions from "../../../store/actions/loaderActions";
import { useTranslation } from "react-i18next";
import { StorageHelper } from "../../../../utils/storageHelper";
import _ from "underscore";
import useResizer from "../../../../hooks/useResizer";
import useDetectClickOutside from "../../../../hooks/useDetectClickOutside";
import APP_CONST from "../../shared/constants";

const Header = ({ setShowSidebar }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { windowDimensions } = useResizer();

  const { studyUserInfo } = useSelector((store) => store.zone);
  const { error } = useSelector((store) => store.loader);
  const { isEtmfLocked } = useSelector((store) => store.template);

  const appSettings = StorageHelper.getAppSettings();

  let logoutRef = useRef();

  useDetectClickOutside(logoutRef, () => setShowLogoutPopUp(false));
  const [showLogoutPopUp, setShowLogoutPopUp] = useState(false);
  const [toggleSidepanel, setToggleSidepanel] = useState(
    StorageHelper.getSidepanelToggle()
      ? StorageHelper.getSidepanelToggle() === "true"
        ? true
        : false
      : true
  );

  const displayName = !_.isEmpty(studyUserInfo)
    ? studyUserInfo.displayName.split("(")[0]
    : "";

  useEffect(() => {
    if (windowDimensions.width < APP_CONST.WINDOW_BREAKPOINT) {
      setShowSidebar(false);
      StorageHelper.setSidepanelToggle(false);
      setToggleSidepanel(false);
    }
  }, [setShowSidebar, windowDimensions]);

  const handleToggleSidepanel = () => {
    setShowSidebar((prevState) => !prevState);
    StorageHelper.setSidepanelToggle(!toggleSidepanel);
    setToggleSidepanel((prevState) => !prevState);
  };

  const onLogout = () => {
    document.cookie = "tokenInfo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" + appSettings.domain + "; path=/";
    document.cookie = "tokenExpiry=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=" + appSettings.domain + "; path=/";
    window.inactivityClient && window.inactivityClient.logOut();
    setShowLogoutPopUp(false);
  };

  const LogoutPopup = () => {
    return (
      <div className="logout-popup" ref={logoutRef}>
        <viedoc-header-menu
          open="true"
          id="header-menu"
          anchor-id="menuButton"
          name={displayName}
          title={displayName}
        >
          <viedoc-header-menu-item ref={logoutRef} title="">
            <viedoc-link onClick={onLogout}>
              {t("COMMON.TEXT_LOGOUT")}
            </viedoc-link>
          </viedoc-header-menu-item>
        </viedoc-header-menu>
      </div>
    );
  };

  const renderViedocDemoStudyButton = () => {
    return (
      <div
        slot="content"
        size="small"
        title={studyUserInfo.studyName}
        className="study-name"
      >
        <viedoc-avatar
          name={!_.isEmpty(studyUserInfo) ? studyUserInfo.studyName : ""}
          slot="prefix"
          alt="Viedoc Demo Study"
          size="small"
          class="mr-5"
        ></viedoc-avatar>
        <div>
          <span>{studyUserInfo.studyName}</span>
        </div>
      </div>
    );
  };

  const renderProfileButton = () => {
    return (
      <viedoc-button
        id="menuButton"
        title={displayName}
        slot="actions"
        size="small"
        onClick={() => setShowLogoutPopUp((prevState) => !prevState)}
      >
        <viedoc-avatar
          title={displayName}
          name={displayName}
          slot="prefix"
          alt={studyUserInfo.displayName}
          size="small"
          class="mr-5"
        ></viedoc-avatar>
        {studyUserInfo.displayName}
      </viedoc-button>
    );
  };

  return (
    <nav className="nav-header">
      <viedoc-header class="viedoc-header">
        <viedoc-link slot="application">
          <div className="ham-icon" onClick={() => handleToggleSidepanel()}>
            <viedoc-icon name="hamburger" />
          </div>
          <a
            href={appSettings.viedocParentUrl}
            style={{ color: "inherit" }}
            title="Viedoc"
          >
            <viedoc-wordmark application-name="tmf"></viedoc-wordmark>
          </a>
        </viedoc-link>
        {!_.isEmpty(studyUserInfo) && (
          <>
            {renderViedocDemoStudyButton()}
            {renderProfileButton()}
          </>
        )}
      </viedoc-header>

      <div
        className={
          error.errorTxt ? "active-error-message" : "inactive-error-message"
        }
      >
        <ViedocToasterElement
          onClick={(e) => {
            e.target?.renderRoot?.activeElement?.className.includes(
              "button--circular"
            ) && dispatch(loaderActions.hideError());
          }}
          borderRadius
          variant={error.variant}
          prefix-icon={error.icon}
          toasterFullWidth
          toasterMsg={error.errorTxt}
        />
      </div>
      <div
        className={
          isEtmfLocked ? "active-error-message" : "inactive-error-message"
        }
      >
        <ViedocToasterElement
          borderRadius
          variant="neutral"
          prefix-icon="lock"
          toasterFullWidth
          isClose={false}
          toasterMsg={t("ADMIN.TEXT_LOCKDESCRIPTION")}
        />
      </div>
      {showLogoutPopUp && <LogoutPopup />}
    </nav>
  );
};

export default Header;
